import { render } from "./memberPaymentModel.vue?vue&type=template&id=0196c89f"
import script from "./memberPaymentModel.vue?vue&type=script&lang=js"
export * from "./memberPaymentModel.vue?vue&type=script&lang=js"

import "./memberPaymentModel.vue?vue&type=style&index=0&id=0196c89f&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__